import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import './hyperlink.css';

/*
#tailwind
hyperlink hyperlink--underlined
*/

const Hyperlink = ({ url, underlined, children, className, ...other }) => (
  <a href={url} target="_blank" rel="noreferrer" className={bem`hyperlink--${{ underlined }} ${className}`} {...other}>
    {children}
  </a>
);

Hyperlink.propTypes = {
  url: PropTypes.string,
  underlined: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
};

Hyperlink.defaultProps = {
  url: undefined,
  underlined: true,
  children: undefined,
  className: undefined,
};

export default Hyperlink;
